import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
          An e-commerce website is an online platform that facilitate buying and
          selling of products or services over the internet serves as a virtual
          marketplace where business and individual showcase their products,
          interact with customers, and conduct transitions without the need for
          physical presence. E-commerce websites have gained immense popularity due to their convenient accessibility, and the global reach they offer.
        </p>
        <p>
          E-commerce websitestypically display products or services and detailed descriptions, images, and any available variations (e.g., sizes, colors). Each product has its own dedicated page with relevent information.
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox
